import { WORKER_MINUTES_MOST, WORKER_TOKENS_MOST, type WorkerLimits } from '../api/types'

const whole = (n: number, most: number) => Number.isInteger(n) && n >= 1 && n <= most

/** As the server checks them (`WorkerLimits::check`): minutes 1–100,000, lifetime at least the working time, a token warning 1–1,000,000,000,000. */
export function validWorkerLimits(limits: WorkerLimits): boolean {
  return whole(limits.working_minutes, WORKER_MINUTES_MOST)
    && whole(limits.lifetime_minutes, WORKER_MINUTES_MOST)
    && limits.lifetime_minutes >= limits.working_minutes
    && whole(limits.token_warning, WORKER_TOKENS_MOST)
}

export const sameWorkerLimits = (a: WorkerLimits | null, b: WorkerLimits | null) =>
  a === b || (a !== null && b !== null && a.working_minutes === b.working_minutes && a.lifetime_minutes === b.lifetime_minutes && a.token_warning === b.token_warning)
